/* Publish by EComposer at 2026-10-14 15:40:13*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-vfa6r5lcyz"]=  window.__ectimmers["ecom-vfa6r5lcyz"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-vfa6r5lcyz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vfa6r5lcyz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jqv5n0uvquo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jqv5n0uvquo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8cj0a8prcad').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8cj0a8prcad', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h0z8vujyfxk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h0z8vujyfxk', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-plhtig0uy6r"]=  window.__ectimmers["ecom-plhtig0uy6r"] || {};
const t=this.$el;if(!t||!this.isLive)return;const e=t.querySelector(".element__featured--wrapper-list");if(e){let i={top:0,left:0,x:0,y:0};const s=function(r){const a=r.clientX-i.x;e.scrollLeft=i.left-a},o=function(){e.removeEventListener("mousemove",s),e.removeEventListener("mouseup",o),e.style.cursor="default",e.style.removeProperty("user-select")},n=function(r){e.style.cursor="grabbing",e.style.userSelect="none",i={left:e.scrollLeft,top:e.scrollTop,x:r.clientX,y:r.clientY},e.addEventListener("mousemove",s),e.addEventListener("mouseup",o)};e.addEventListener("mousedown",n),e.addEventListener("mouseleave",o)}

                    });
                    
                        document.querySelectorAll('.ecom-plhtig0uy6r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-plhtig0uy6r', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-zu1m2aufxpg"]=  window.__ectimmers["ecom-zu1m2aufxpg"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-zu1m2aufxpg"]["wqs7hnri3"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-zu1m2aufxpg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zu1m2aufxpg', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-up9lak1nr3k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-up9lak1nr3k', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vmkt0ahok5m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vmkt0ahok5m', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-09f2gne0fe3k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-09f2gne0fe3k', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d52sdn2irhs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d52sdn2irhs', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k5fnvl8oqr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k5fnvl8oqr', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}